export const blogsList = [
    {
        img: "https://res.cloudinary.com/nj1508/image/upload/v1661790398/mp/mp-b1.jpg",
        title: "Let's discuss authorization strategies!!",
        date: "May 12, 2022",
        link: "https://namratajain.hashnode.dev/lets-discuss-authorization-strategies",
        description: "Do you find it difficult to understand things when it..."
    },
    {
        img: "https://res.cloudinary.com/nj1508/image/upload/v1661790544/mp/mp-b2.jpg",
        title: "What are HTTP Requests and HTTP responses!!?? How do both of them differ!?",
        date: "May 11, 2022",
        link: "https://namratajain.hashnode.dev/what-are-http-requests-and-http-responses-how-do-both-of-them-differ",
        description: "HTTP Request vs HTTP Response vs HTTP Methods vs HTTP headers vs HTTP status..."
    },
    {
        img: "https://res.cloudinary.com/nj1508/image/upload/v1661790647/mp/mp-b3.jpg",
        title: "programming language vs scripting language",
        date: "Feb 27, 2022",
        link: "https://namratajain.hashnode.dev/programming-language-vs-scripting-language",
        description: "Is scripting language also a programming language!? Hi folks, As promised..."
    },
    {
        img: "https://res.cloudinary.com/nj1508/image/upload/v1661790759/mp/mp-b4.jpg",
        title: "transpiler vs compiler vs interpreter",
        date: "Feb 27, 2022",
        link: "https://namratajain.hashnode.dev/transpiler-vs-compiler-vs-interpreter",
        description: "same same but different!! · Hi folks!! As promised i am back with an amazing..."
    },
    {
        img: "https://res.cloudinary.com/nj1508/image/upload/v1661790940/mp/mp-b5.jpg",
        title: "I got stucked while using onChange event in vanillaJs, know why!?",
        date: "Oct 3, 2021",
        link: "https://namratajain.hashnode.dev/i-got-stucked-while-using-onchange-event-in-vanillajs-know-why",
        description: "You learn when you make mistakes, you learn from your failures, and..."
    },
    {
        img: "https://res.cloudinary.com/nj1508/image/upload/v1661791023/mp/mp-b6.jpg",
        title: "Switching Techniques in computer networking!!",
        date: "Sep 14, 2021",
        link: "https://namratajain.hashnode.dev/switching-techniques-in-computer-networking",
        description: "What is switching!? How many types of switching techniques are..."
    },
    {
        img: "https://res.cloudinary.com/nj1508/image/upload/v1661791115/mp/mp-b7.jpg",
        title: "What does encodeURI() mean!?",
        date: "Aug 10, 2021",
        link: "https://namratajain.hashnode.dev/what-does-encodeuri-mean",
        description: "Why encoding is needed and how is it helpful? Before getting into..."
    }
];